import useProductVariant from 'hooks/useProductVariant'
import ProductVariantGroup from 'snippets/product/product-variant/product-variant-group'

const selectors = {
  DEFAULT_VARIANT_TITLE: 'Default Title'
}

function ProductVariant({
  options,
  variants,
  type = 'button',
  updateUrl = true,
  currentVariant,
  updateCurrentVariant,
  hasOnlyDefaultVariant = false,
  giftCard = false,
  isModalLayout = false
}) {
  const isOnlyVariantDefault =
    hasOnlyDefaultVariant || (variants.length === 1 && variants[0].title === selectors.DEFAULT_VARIANT_TITLE)

  if (isOnlyVariantDefault) return null

  const { selected, setSelected, availableValues, selectableValues } = useProductVariant({
    variants,
    options,
    updateUrl,
    currentVariant,
    updateCurrentVariant
  })

  return (
    <div className="flex flex-col text-sm">
      {Object.entries(availableValues).map(([key, values]) => (
        <ProductVariantGroup
          key={key}
          name={key}
          type={type}
          values={values}
          selected={selected}
          setSelected={setSelected}
          selectableValues={selectableValues}
          giftCard={giftCard}
          isModalLayout={isModalLayout}
        />
      ))}
    </div>
  )
}

export default ProductVariant
